import { Badge } from "@arcadeai/design-system/components/ui/atoms/badge";
import { cn } from "@arcadeai/design-system/lib/utils";
import { getRoleStyle } from "@/app/roles/lib/role-style";
import type { RoleRef } from "@/app/roles/types";

type RoleBadgeProps = {
  role: RoleRef;
  /** Hide the leading icon (e.g. in dense table cells). */
  hideIcon?: boolean;
  className?: string;
};

/** A compact, read-only badge showing a role's name with a role-appropriate icon. */
export function RoleBadge({
  role,
  hideIcon = false,
  className,
}: RoleBadgeProps) {
  const { icon: Icon, className: toneClassName } = getRoleStyle(role.key);

  return (
    <Badge
      className={cn(
        "h-6 gap-1.5 rounded-lg px-2.5 font-semibold text-[11px] leading-none",
        toneClassName,
        className
      )}
      variant="outline"
    >
      {!hideIcon && <Icon className="size-3.5!" />}
      {role.display_name}
    </Badge>
  );
}
